module.exports = __webpack_public_path__ + "img/10.8b7a5a34.jpg";